import { Component, Input, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
import { IDatasetConfig, IDatasetPropertyDefinition } from 'app/interfaces';
import {DatasetService} from 'app/main/components/dataset/services/dataset.service';
import {DatasetRecordService } from 'app/main/components/dataset/services/dataset-record.service';
import {DatasetActionContainerService} from 'app/main/components/dataset/services/dataset-action-container.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import {AuthService} from 'app/services/auth.service';
import { takeUntil } from 'rxjs/operators';
import { buildPropertyFormFields, filterProperties } from 'app/helpers/property-field.helper';

@Component({
    selector: 'dynamic-dataset-properties-data-viewer',
    templateUrl: './dynamic-dataset-properties-data-viewer.component.html',
    styleUrls: ['./dynamic-dataset-properties-data-viewer.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DynamicDatasetPropertiesDataViewerComponent implements OnInit, OnDestroy{

	@Input() public only: string[];
	@Input() public exclude: string[];

	public datasetConfig: IDatasetConfig;
	private _unsubscribeAll: Subject<void>;
	public propertyDefinitions: BehaviorSubject<IDatasetPropertyDefinition[]>;

	public fields: any[];

	constructor(
		protected route: ActivatedRoute,
		protected datasetService: DatasetService,
		protected dialog: MatDialog,
		protected router: Router,
		protected authService: AuthService,
		public datasetACS: DatasetActionContainerService,
		public datasetRS: DatasetRecordService
	){
		this._unsubscribeAll = new Subject();
		this.propertyDefinitions = new BehaviorSubject(null);
	}

	ngOnInit(): void{
		this.datasetACS.ready
		.pipe(takeUntil(this._unsubscribeAll))
		.subscribe(ready => { 
			if(!ready) return;
			if(this.datasetACS.datasetConfig){
				const targets = this.datasetACS.getValueFromKeyPath(this.datasetACS.datasetConfig.name + '_property_definition_targets');
				const filteredTargets = filterProperties(targets, this.datasetRS.record.value);
				this.propertyDefinitions.next(filteredTargets);
			}
		});

		this.propertyDefinitions
		.pipe(takeUntil(this._unsubscribeAll))
		.subscribe(_ => {
			const formConfig = buildPropertyFormFields(this.propertyDefinitions.value, this.datasetRS.record.value,  {
				only: this.only,
				exclude: this.exclude
			});
			this.fields = formConfig.fields;
		});
	}

	ngOnDestroy(): void{
		this._unsubscribeAll.next();
		this._unsubscribeAll.complete();
	}
}
